import { render } from "./pot-base-salary.vue?vue&type=template&id=c54a7b90"
import script from "./pot-base-salary.vue?vue&type=script&lang=js"
export * from "./pot-base-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/pot/pot-base-salary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c54a7b90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c54a7b90', __exports__)) {
    api.reload('c54a7b90', __exports__)
  }
  
  module.hot.accept("./pot-base-salary.vue?vue&type=template&id=c54a7b90", () => {
    api.rerender('c54a7b90', render)
  })

}


export default __exports__